module.exports = __webpack_public_path__ + "img/bg-lg.8bd8f578.svg";